import { hideAllModals, setError, showModal, startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { LEFT_NAV_TYPES } from '@constants/actionTypes/leftNavTypes';
import { NAV_BAR_TYPES } from '@constants/actionTypes/navBarActionTypes';
import API from '@services/API';
import { resultsActionTypes } from './actionTypes';

import { SPINNER_MESSAGES_IDS } from '@constants/common/miscellaneous';
import { commonModalTypes as MODAL_TYPES } from '@constants/common/modals/commonModalTypes';
import { configs } from '@constants/configs/configs';

export const setNavBarData = navBarData => ({
    type: NAV_BAR_TYPES.SET_NAV_BAR_DATA,
    navBarData,
});

export const setLeftNavParams = leftNavParams => ({
    type: LEFT_NAV_TYPES.SET_LEFT_NAV_PARAMS,
    leftNavParams,
});

/************************

 # Async action creators

 ************************/

const actions = { setError, startSpinner, stopSpinner };

export const fetchNavBarData = url => async dispatch => {
    const data = await API.getData(url, dispatch, actions);
    if (data) {
        dispatch(setNavBarData(data.menu));
    }
};

export const fetchLeftNavParams = url => async (dispatch, getState) => {
    const data = await API.getData(url, dispatch, actions, true, getState());
    if (data) {
        dispatch(setLeftNavParams(data));
    }
};

export const setIdProofingData = responseData => ({
    type: resultsActionTypes.SET_ID_PROOFING_RESPONSE_DATA,
    responseData,
});


export const idProofing =
    (...args) =>
        async dispatch => {
            const [url, body] = args;
            const { attested, firstName, lastName, birthDate, documentNumber, documentType, method, history, redirectUrl } =
                body;
            const postParams = { attested, firstName, lastName, birthDate, documentNumber, documentType, method };
            const params = [url, postParams, undefined, false, undefined, 'application/json'];
            const data = configs.ENV.DEVELOPMENT
                ? await API.getData(url, dispatch, actions, true)
                : await API.postData(params, dispatch, actions);

            if (data && data.statusCode === 200) {
                dispatch(actions.startSpinner(SPINNER_MESSAGES_IDS.SAVING_DATA));
                dispatch(setIdProofingData(data));
                setTimeout(() => {
                    history.push(redirectUrl);
                    dispatch(actions.stopSpinner());
                }, 3000);
            } else {
                console.log('something went wrong');
            }
        };

export const setfetchEnrollerDetailsData = responseData => ({
    type: resultsActionTypes.SET_FETCH_ENROLLER_DETAILS_RESPONSE_DATA,
    responseData,
});


export const fetchEnrollerDetails =
    (...args) =>
        async dispatch => {
            const [url] = args;
            const data = await API.getData(url, dispatch, actions, true);
            if (data) {
                dispatch(setfetchEnrollerDetailsData(data));
            } else {
                console.log('something went wrong');
            }
        };

export const setResultsData = resultsData => ({
    type: resultsActionTypes.SET_EDE_SEARCH_RESULTS_DATA,
    resultsData,
});

export const clearSearchResultsData = () => ({
    type: resultsActionTypes.CLEAR_EDE_SEARCH_RESULTS,
});

export const clearEDESearch = () => async dispatch => {
    dispatch(clearSearchResultsData());
};

export const edeSearch =
    (...args) =>
        async dispatch => {
            const [url, body] = args;
            const { id, passIdentityProofId, scrollSmoothHandler } = body;

            const params = [url, passIdentityProofId, undefined, false, undefined, 'application/json'];
            const data = configs.ENV.DEVELOPMENT
                ? await API.getData(url, dispatch, actions, true)
                : await API.postData(params, dispatch, actions);
            if (data) {
                dispatch(actions.startSpinner(SPINNER_MESSAGES_IDS.SEARCHING_DATA));
                setTimeout(() => {
                    dispatch(actions.stopSpinner());
                    dispatch(setResultsData(data));
                    id && scrollSmoothHandler(id);
                }, 2000);
            } else {
                console.log('there is an error in fetching edeSearch results');
            }
        };

export const addToBOB =
    (...args) =>
        async dispatch => {
            const [url, modalData] = args;

            const params = [url, modalData, undefined, false, undefined, 'application/json'];
            const data = configs.ENV.DEVELOPMENT
                ? await API.getData(url, dispatch, actions, false)
                : await API.postData(params, dispatch, actions);
            dispatch(hideAllModals());
            if (data && data.statusCode === 200) {
                dispatch(
                    showModal({
                        modalType: MODAL_TYPES.ADDED_TO_BOB_MODAL,
                        modalData: {
                            memberName: modalData.memberName,
                        },
                    }),
                );
            } else {
                console.log('there is an error in fetching edeSearch results');
            }
        };
